<div class="login-header">
  <span [routerLink]="link" class="material-symbols-outlined">west </span>
  <h1>{{ title }}</h1>
</div>
